// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"9fbfd5a5","990":"0f33550a"}[chunkId] + ".chunk.js";
};